/* SSS PDP gallery: isolate all product views by current color, every PDP layout. */
(function(){
  if(window.__sssPdpGalleryLoaded)return;window.__sssPdpGalleryLoaded=true;
  const normalize=s=>String(s||'').trim().toLowerCase();
  const stem=s=>{
    if(!s)return'';
    let path;try{path=new URL(s,location.origin).pathname;}catch(e){path=String(s).split('?')[0];}
    let name=decodeURIComponent(path.split('/').pop()||'').replace(/\.[^.]+$/,'');
    return name.replace(/[-_]0[1-9](?:[-_].*)?$/i,'').toLowerCase();
  };
  const products=new Map();
  function metadata(){
    document.querySelectorAll('script[data-sss-gallery-product]').forEach(n=>{
      if(products.has(n.dataset.sssGalleryProduct))return;
      try{const product=JSON.parse(n.textContent);const mediaNode=document.querySelector('script[data-sss-gallery-media="'+n.dataset.sssGalleryProduct+'"]');if(mediaNode)product.media=JSON.parse(mediaNode.textContent);products.set(n.dataset.sssGalleryProduct,product);}catch(e){}
    });
  }
  function imagesFor(product,color){
    const variants=product.variants||[];
    const colorPosition=(product.options||[]).findIndex(o=>normalize(typeof o==='string'?o:o.name).includes('color')||normalize(typeof o==='string'?o:o.name).includes('colour'));
    if(colorPosition<0)return null;
    const matches=variants.filter(v=>normalize(v.options?.[colorPosition])===normalize(color));
    const prefixes=new Set(matches.map(v=>stem(v.featured_image?.src||v.featured_media?.preview_image?.src)).filter(Boolean));
    return prefixes.size?prefixes:null;
  }
  function ensureLandingColor(product,sectionId){
    const options=product.options||[];
    const opt=options.findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name||''));
    if(opt<0)return;
    const picker=document.querySelector('variant-radios[data-section="'+sectionId+'"],variant-selects[data-section="'+sectionId+'"]');
    if(!picker)return;
    const id=new URLSearchParams(location.search).get('variant');
    const variants=product.variants||[];
    const fromUrl=variants.find(v=>String(v.id)===id);
    const chosen=fromUrl||variants.find(v=>v.available)||variants[0];
    const color=chosen?.options?.[opt];
    if(!color)return;
    const controls=[...picker.querySelectorAll('input[type="radio"]')].filter(el=>/colou?r/i.test(el.name||''));
    const target=controls.find(el=>normalize(el.value)===normalize(color));
    if(target){
      if(!picker.dataset.sssLandingColorApplied){
        controls.forEach(el=>{el.checked=(el===target);});
        picker.dataset.sssLandingColorApplied='1';
      }else if(!controls.some(el=>el.checked)){
        target.checked=true;
      }
    }
    const selected=controls.find(el=>el.checked);
    const label=document.getElementById('ColorName-'+sectionId);
    if(selected&&label)label.textContent=selected.value;
  }
  function currentColor(product,sectionId){
    const opt=(product.options||[]).findIndex(o=>/colou?r/i.test(typeof o==='string'?o:o.name));
    if(opt<0)return null;
    const picker=document.querySelector('variant-radios[data-section="'+sectionId+'"],variant-selects[data-section="'+sectionId+'"]');
    if(picker){
      const controls=picker.querySelectorAll('.product-form__controls');
      for(const group of controls){
        const title=normalize(group.querySelector('legend,.product-form__label,.form__label')?.textContent);
        if(!title.includes('color')&&!title.includes('colour'))continue;
        const selected=group.querySelector('input:checked,select');
        if(selected)return selected.value;
      }
      const selected=picker.querySelectorAll('input:checked,select');
      if(selected[opt])return selected[opt].value;
    }
    const id=new URLSearchParams(location.search).get('variant');
    const variant=(product.variants||[]).find(v=>String(v.id)===id)||(product.variants||[]).find(v=>v.available)||(product.variants||[])[0];
    return variant?.options?.[opt]||null;
  }
  function apply(){
    metadata();
    products.forEach((product,sectionId)=>{
      const root=document.getElementById('MainProduct-'+sectionId);
      if(!root)return;
      ensureLandingColor(product,sectionId);
      const color=currentColor(product,sectionId);
      const prefixes=imagesFor(product,color);
      if(!prefixes){root.classList.add('sss-gallery-ready');return;}
      const media=product.media||[];
      const allowed=new Set();
      for(const m of media){
        if(m.media_type!=='image'){allowed.add(String(m.id));continue;}
        const src=m.preview_image?.src||m.src||m.image?.src||'';
        const s=stem(src);
        // Azura's OF-FALL-01 on-foot shot is style-level media (no color code).
        // Keep it in the selected-color gallery without exposing other colorways.
        const azuraOnFoot=normalize(product.vendor)==='azura' &&
          /-OF-FALL-01(?:_[^/.?]+)?\.(?:png|jpe?g|webp|avif)(?:[?#]|$)/i.test(src);
        if(prefixes.has(s)||azuraOnFoot)allowed.add(String(m.id));
      }
      if(!allowed.size){root.classList.add('sss-gallery-ready');return;}
      const modal=document.getElementById('ProductModal-'+sectionId);
      let changed=false;
      [root,modal].filter(Boolean).forEach(container=>{
        container.querySelectorAll('.product__media-item[data-media-id],.product__media-subitem[data-media-sub-id],.product-media-modal__item[data-media-modal-id]').forEach(el=>{
          const key=el.dataset.mediaId||el.dataset.mediaSubId||el.dataset.mediaModalId||'';
          const id=key.split('-').pop();
          if(!/^\\d+$/.test(id))return;
          const show=allowed.has(id);
          if(el.classList.contains('sss-other-color-media')===show){
            el.classList.toggle('sss-other-color-media',!show);
            changed=true;
          }
          const aria=show?'false':'true';
          if(el.getAttribute('aria-hidden')!==aria)el.setAttribute('aria-hidden',aria);
        });
      });
      if(changed){
        [root,modal].filter(Boolean).forEach(container=>{
          container.querySelectorAll('.swiper').forEach(el=>{
            const swiper=el.swiper;
            if(!swiper||swiper.destroyed)return;
            try{
              swiper.update();
              const active=swiper.slides?.[swiper.activeIndex];
              if(active?.classList.contains('sss-other-color-media')){
                const visible=Array.from(swiper.slides).findIndex(sl=>!sl.classList.contains('sss-other-color-media'));
                if(visible>=0)swiper.slideTo(visible,0,false);
              }
            }catch(e){}
          });
        });
      }
      root.classList.add('sss-gallery-ready');
    });
  }
  let timeout;
  const schedule=()=>{clearTimeout(timeout);timeout=setTimeout(apply,30);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply,{once:true});else apply();
  document.addEventListener('change',e=>{if(e.target.closest('variant-radios,variant-selects'))schedule();},true);
  document.addEventListener('sss:variant-picker-updated',schedule);
  document.addEventListener('shopify:section:load',schedule);
  new MutationObserver(m=>{if(m.some(x=>x.addedNodes.length&&Array.from(x.addedNodes).some(n=>n.nodeType===1&&(n.matches?.('[data-section^="product-media-"]')||n.querySelector?.('[data-section^="product-media-"]')))))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
})();